import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const RemoveIcon = ({
  title = 'RemoveIcon',
  className = 'remove-icon',
  viewBox = '0 0 24 24',
  fill = 'currentColor',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} className={className} viewBox={viewBox} {...props} fill="none">
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5697 3.56965C21.1345 4.13452 21.1547 5.03781 20.6302 5.62685L20.5697 5.69098L14.1213 12.1389L20.4009 18.4189C20.9867 19.0047 20.9867 19.9544 20.4009 20.5402C19.836 21.1051 18.9328 21.1253 18.3437 20.6007L18.2796 20.5402L12 14.2602L5.72041 20.5402C5.13462 21.126 4.18487 21.126 3.59909 20.5402C3.03422 19.9754 3.01405 19.0721 3.53857 18.483L3.59909 18.4189L9.87868 12.1389L3.43035 5.69098C2.84456 5.10519 2.84456 4.15544 3.43035 3.56965C3.99521 3.00479 4.89851 2.98461 5.48755 3.50913L5.55167 3.56965L12 10.0175L18.4483 3.56965C19.0341 2.98387 19.9839 2.98387 20.5697 3.56965Z"
      fill={fill}
    />
  </CreateIconComponent>
);

export default RemoveIcon;
